import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ColorPicker from 'rc-color-picker';
import 'rc-color-picker/assets/index.css';

// Import Style
import './styles.scss';

export class withColorRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      color: null,
      displayColorPicker: false
    };

    this.colorPickerRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleChange = ev => {
    const filter = document.querySelector('.resize_container .filter');
    this.setState({ color: ev.color, displayColorPicker: true });
    filter && filter.classList.add('no-scroll');
  };

  handleChangeComplete = ev => {
    if (typeof this.props.onColorChange === 'function' && !ev.open && ev.color !== this.props.option.color) {
      this.props.onColorChange(ev.color);
    }
  };

  handleOnclickColorPicker = () => {
    const { displayColorPicker } = this.state;
    const filter = document.querySelector('.resize_container .filter');
    this.setState({
      displayColorPicker: !displayColorPicker
    });
    if (!!filter) {
      if (!displayColorPicker) {
        filter.classList.add('no-scroll');
      } else {
        if (filter.classList.contains('no-scroll')) {
          filter.classList.remove('no-scroll');
        }
      }
    }
  };

  handleClickOutside = event => {
    const filter = document.querySelector('.resize_container .filter');
    if (this.colorPickerRef.current && !this.colorPickerRef.current.contains(event.target)) {
      this.setState({
        displayColorPicker: false
      });
      if (!!filter && filter.classList.contains('no-scroll')) {
        filter.classList.remove('no-scroll');
      }
    }
  };

  render() {
    const { colorsChangable, label, option } = this.props;
    const styles = {
      color: {
        background: !this.state.color ? option.color : this.state.color
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer'
      },
      popover: {
        position: 'absolute',
        zIndex: '2'
      },
      cover: {
        position: 'fixed',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0'
      },
      noMarginLeft: {
        marginLeft: '2px',
        position: 'relative',
        top: '-1px'
      }
    };

    return (
      <div ref={this.colorPickerRef}>
        {!!colorsChangable && option.value !== 'no-option' && option.value !== 'no-label' && option.color ? (
          <ColorPicker
            defaultAlpha={70}
            enableAlpha={false}
            color={this.state.color ? this.state.color : option.color}
            onChange={this.handleChange}
            onClose={this.handleChangeComplete}
            align={{
              points: ['br', 'cc']
            }}
          >
            
            <span className="react-custom-trigger">
              <div
                onClick={() => this.handleOnclickColorPicker()}
                className='color-dot arrow'
                style={styles.color}
              ></div>
            </span>
          </ColorPicker>
        ) : (
          <span className="react-custom-trigger">
            <div className='color-dot ml-no-option' style={styles.color}></div>
          </span>
        )}
        <span>
          <span style={styles.noMarginLeft}>{option.label ? label : '(no name)'}</span>
        </span>
      </div>
    );
  }
}

withColorRenderer.propTypes = {
  label: PropTypes.string.isRequired,
  option: PropTypes.object,
  fieldId: PropTypes.string,
  colorsChangable: PropTypes.bool,
  onColorChange: PropTypes.func
};
